module.exports = __webpack_public_path__ + "static/media/218RO.68053a11.jpg";